<template>
    <LayoutDashboard title="Atualizar Senha">
        <v-card outlined>
            <Alert />
            <form @submit.prevent="atualizar">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field label="Senha" id="id" type="password" v-model="password" class="mr-2 ml-2" outlined dense></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field label="Confirmação de Senha" id="id" type="password" v-model="password_confirmation" class="mr-2 ml-2" outlined dense></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success" type="submit" block outlined>Salvar</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </LayoutDashboard>
</template>
<script>
    import FuncionarioService from '@/services/FuncionarioService'
    import {mapActions} from "vuex"
    export default {
        data() {
            return {
                password: '',
                password_confirmation: '',
            }
        },
        methods: {
            ...mapActions([
                'atualizarSenhaFuncionario'
            ]),
            atualizar(){
                this.atualizarSenhaFuncionario({
                    password: this.password,
                    password_confirmation: this.password_confirmation
                })
            }
        }
    }
</script>